const VxeLoading = {
  /* eslint-disable @typescript-eslint/no-empty-function */
  install () {}
}

export const Loading = VxeLoading
export default VxeLoading
